module.exports = __webpack_public_path__ + "static/img/8-5.9a06caf4.jpg";